module.exports = __webpack_public_path__ + "static/media/8.5755bb24.jpg";